"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  recommendedDate: 'Date recommended for selection',
  notRecommendedDate: 'Date not recommended for selection'
};